import axios from 'axios';

//https://localhost:44328
const resolveBaseURL = () => {
  try {
    const { hostname } = window.location;
    if (hostname.includes('localhost')) {
      return 'https://adminrotary.codiatest.com/';
    }
    return window.location.origin;
  } catch (e) {
    return 'https://adminrotary.codiatest.com/';
  }
};

export const httpClientNewsletter = axios.create({
  baseURL: resolveBaseURL(),
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json, text/plain',
  },
  withCredentials: true,
});

httpClientNewsletter.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth.token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

httpClientNewsletter.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default httpClientNewsletter;

export const resolveNewsletterAssetUrl = (path) => {
  if (!path || typeof path !== 'string') return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  const base = resolveBaseURL();
  return `${base}${path}`;
};
